import axios from 'axios'

axios.interceptors.response.use(
    response => response,
    error => {
        if(error.response && error.response.status === 401){
            window.location.href = route('login');
        }
        return Promise.reject(error)
    }
)
